import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStore from '@app/auth/store';
import { Login } from '@app/auth/store/actions/auth.actions';
import { Authenticate } from '@app/auth/models/authentication.model';

@Component({
  selector: 'app-login-modal',
  template: `
    <div class="modal-body">
      <app-login-form
        [error]="error$ | async"
        [disabled]="pending$ | async"
        (submitted)="onLogin($event)"
      >
      </app-login-form>
    </div>
  `
})
export class LoginPromptComponent implements OnInit {
  error$ = this.store.select(fromStore.selectLoginPageError);
  pending$ = this.store.select(fromStore.selectLoginPagePending);

  constructor(private store: Store<fromStore.State>) {}

  ngOnInit() {}

  onLogin(credentials: Authenticate) {
    this.store.dispatch(new Login(credentials));
  }
}
